<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
    </el-button-group>

    <el-table :data="orderDownloads" resource="downloads">
      <el-table-column prop="id" label="ID" width="60" />

      <el-table-column label="文件名">
        <template slot-scope="scope">
          <el-link v-if="scope.row.status==1 && hasPermsDownload" icon="el-icon-download" :href="scope.row.url" target="_blank">{{scope.row.name}}</el-link>
          <span v-else>{{scope.row.name}}</span>
        </template>
      </el-table-column>

      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0">处理中</el-tag>
          <el-tag v-else-if="scope.row.status == 1" type="success">完成</el-tag>
          <el-tag v-else-if="scope.row.status == 2" type="danger">失败</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="typeText" label="类型" />

      <el-table-column prop="created_at" label="添加时间" width="170" />
      <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <el-button v-if="row.status==1 && hasPermsDownload" type="primary" size="small" @click="download(row.url)">下载</el-button>
            <row-destroy />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
  import SearchForm from '@c/SearchForm'
  import Pagination from '@c/Pagination'
  import { getDownloads } from '@/api/downloads'
  import RowDestroy from '@c/LzTable/RowDestroy'
  import RowToEdit from '@c/LzTable/RowToEdit'
  import { can } from '@/libs/utils'

  export default {
    name: 'Index',
    components: {
      RowToEdit,
      RowDestroy,
      SearchForm,
      Pagination,
    },
    data() {
      return {
        search: [
          {
            field: 'name',
            label: '名称',
          },
          {
            field: 'status',
            label: '状态',
            type: 'el-select',
            options: [{
              id: 0,
              name: '处理中'
            }, {
              id: 1,
              name: '完成'
            }, {
              id: 2,
              name: '未完成'
            }],
            labelField: 'name',
            valueField: 'id'
          },
        ],
        orderDownloads: [],
        page: null,
        loading: true,
        hasPermsDownload: false,
      }
    },
    methods: {
      download(url) {
        location.href = url;
      }
    },
    watch: {
      $route: {
        async handler(newVal) {
          const { data: { data, meta } } = await getDownloads(newVal.query)
          this.orderDownloads = data
          this.page = meta
          this.loading = false;
        },
        immediate: true,
      },
    },
    created() {
      this.hasPermsDownload = can('downloads.download');
    }
  }
</script>
